import { MaskedLine, Reveal } from "./motion";

const PARAGRAPHS = [
    "Depuis toujours, j'ai un œil attiré par les détails, la lumière et la création.",
    "Avant même de tenir un appareil photo, j'aimais dessiner. À l'école, j'ai participé à des concours de dessin et j'aimais déjà chercher la précision, les formes et les petits détails qui font la différence.",
    "Avec les années, cette passion pour la création s'est naturellement transformée en passion pour la photographie. Depuis plus de 13 ans, je photographie les gens, les familles, les animaux, les chevaux, les paysages, les spectacles et tous ces moments qui méritent d'être conservés.",
    "Je suis quelqu'un de minutieux. J'aime prendre le temps de regarder une image, de travailler la lumière, les couleurs et chaque détail pour arriver au résultat que j'ai en tête.",
    "Pour moi, une belle photographie ne consiste pas seulement à appuyer sur le déclencheur. C'est une question de regard, de précision et de passion.",
    "Je travaille mes photographies avec Adobe Lightroom et Photoshop, toujours à partir de mes propres prises de vue. La photographie reste réelle; la retouche me permet simplement d'y apporter ma signature et cette petite touche de magie.",
    "Aujourd'hui, que ce soit dans mon studio maison, à l'extérieur ou sur le terrain, mon objectif reste le même :",
];

export default function AproposDeMoi() {
    return (
        <section
            id="a-propos-de-moi"
            data-testid="section-apropos-moi"
            className="relative overflow-hidden border-t border-[#D4AF37]/15 py-24 sm:py-32"
        >
            <div className="glow-pulse pointer-events-none absolute left-1/2 top-1/3 h-[50vh] w-[70vw] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.07),transparent_65%)]" />

            <div className="relative z-10 mx-auto max-w-2xl px-5 sm:px-10">
                <Reveal>
                    <p className="font-mono-lux mb-8 flex items-center justify-center gap-4 text-[11px] tracking-[0.4em] text-[#D4AF37]">
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                        DANIEL DULUDE — PHOTOGRAPHE
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                    </p>
                </Reveal>
                <h2
                    data-testid="apropos-moi-title"
                    className="font-display text-center text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl"
                >
                    <MaskedLine delay={0.1}>
                        À PROPOS <span className="text-[#8A8A8E]">DE</span>{" "}
                        <span className="text-gold-grad italic">MOI</span>
                    </MaskedLine>
                </h2>
                <Reveal delay={0.2}>
                    <p className="font-mono-lux mt-5 text-center text-[11px] tracking-[0.35em] text-[#8A8A8E]">
                        LE GARS DERRIÈRE LA PHOTO
                    </p>
                </Reveal>

                <Reveal delay={0.3}>
                    <div
                        data-testid="apropos-moi-text"
                        className="mt-12 space-y-6 text-base font-light leading-relaxed text-[#E2E2E2]/90 sm:text-lg"
                    >
                        <p className="first-letter:font-display first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:text-6xl first-letter:leading-[0.8] first-letter:text-[#D4AF37]">
                            {PARAGRAPHS[0]}
                        </p>
                        {PARAGRAPHS.slice(1).map((p) => (
                            <p key={p.slice(0, 24)}>{p}</p>
                        ))}
                        <p className="font-display pt-2 text-center text-xl font-light italic leading-relaxed text-[#D4AF37] sm:text-2xl">
                            « Créer des images que vous aurez envie de
                            regarder encore et encore. »
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
